
import { defineComponent, getCurrentInstance, computed, ref } from "vue";
import { GameUtils } from "@/utils/GameUtils";
import { createToast } from 'mosha-vue-toastify';
import { useStore } from 'vuex';
import 'mosha-vue-toastify/dist/style.css'
import { game } from "@/store/game";


export default defineComponent({
  name: 'gamesFeedbackModal',
  emits: ['closeFeedbackModal', 'updateRating'],
  props: {
    gameId: String,
    title: String,
    displayFeedbackModal: Boolean,
  },
  setup(props, context) {
    const store = useStore();
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;

    const userData = store.getters['auth/user'];
    const username = ref(userData.username);

    const isSubmittingFeedback = ref(false);
    const enableSubmitButton = computed(() => {
      if (message.value.length >= 5 && !isSubmittingFeedback.value) {
        return true;
      } else {
        return false;
      }
    });

    const message = ref('');
    const rates = ref('');
    const submitFeedback = async () => {
      isSubmittingFeedback.value = true;
      let feedback = await GameUtils.feedbackGame(props.gameId, message.value);
      let rating = await GameUtils.rateGame(props.gameId, rates.value)
      if (feedback.feedbackStatus || rating.ratingStatus) {
        // emit close feedbacl form event
        // displayFeedbackModal.value = false;
        context.emit('closeFeedbackModal','updateRating');
        isSubmittingFeedback.value = false;
        message.value = '';
        rates.value = '';
        createToast(
          {
            title: 'Feedback submitted',
            description: feedback.msg,
          },
          {
            position: "bottom-right",
            type: "success",
            timeout: 5000
          }
        );
      }
    }


    const emitToUsername = () => {
      emitter.emit('SWITCH_TO_USERNAME_LOGIN');
    }
    return {
      username,
      isSubmittingFeedback,
      enableSubmitButton,
      message,
      rates,
      submitFeedback,
      emitToUsername,
    }
  }
});
